export default "__VITE_ASSET__CMAYQyra__"